import React, { useState } from "react";
import { Layout, Menu, Typography, Select, Grid } from "antd";
import Setting_PlayQuestions from "./Setting_PlayQuestions";
import Setting_LinkRecommend from "./Setting_LinkRecommend";
import Setting_ChatTimeLimit from "./Setting_ChatTimeLimit";
import InfoSend_UserWebNotice from "./InfoSend_UserWebNotice";
import "../../styles/global.css";

const { Sider, Content } = Layout;
const { Divider } = Menu;
const { useBreakpoint } = Grid;

const MENU_OPTIONS = [
  { key: "quiz", label: "3択クイズの管理" },
  { key: "riddle", label: "なぞなぞの管理" },
  { key: "web_recommend", label: "Webおすすめ" },
  { key: "youtube_recommend", label: "Youtubeおすすめ" },
  { key: "chat_time_limit", label: "チャット時間制限" },
  { key: "userweb_notice_all", label: "ユーザーWeb全体お知らせ" },
] as const;

const SettingsTab: React.FC = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [selectedMenu, setSelectedMenu] = useState<string>("quiz");

  const renderContent = () => {
    switch (selectedMenu) {
      case "quiz":
        return <Setting_PlayQuestions questionType="quiz" />;
      case "riddle":
        return <Setting_PlayQuestions questionType="riddle" />;
      case "web_recommend":
        return <Setting_LinkRecommend kind="web" />;
      case "youtube_recommend":
        return <Setting_LinkRecommend kind="youtube" />;
      case "chat_time_limit":
        return <Setting_ChatTimeLimit />;
      case "userweb_notice_all":
        return <InfoSend_UserWebNotice target="all" inline />;
      default:
        return null;
    }
  };

  const getTitle = () => {
    switch (selectedMenu) {
      case "quiz":
        return "3択クイズの管理";
      case "riddle":
        return "なぞなぞの管理";
      case "web_recommend":
        return "Webおすすめ（全端末共通）";
      case "youtube_recommend":
        return "Youtubeおすすめ（全端末共通）";
      case "chat_time_limit":
        return "チャット時間制限（全端末共通）";
      case "userweb_notice_all":
        return "ユーザーWeb 全体お知らせ";
      default:
        return "共通設定";
    }
  };

  if (isMobile) {
    return (
      <div style={{ minWidth: 0, width: "100%" }}>
        <Select
          value={selectedMenu}
          onChange={setSelectedMenu}
          style={{ width: "100%", marginBottom: 12 }}
          options={MENU_OPTIONS.map((o) => ({ value: o.key, label: o.label }))}
        />
        <Typography.Title level={4} style={{ marginTop: 0 }}>
          {getTitle()}
        </Typography.Title>
        {renderContent()}
      </div>
    );
  }

  return (
    <Layout className="layout-container">
      <Sider style={{ background: "#f0f2f5" }} width={200}>
        <Menu
          mode="inline"
          selectedKeys={[selectedMenu]}
          style={{ height: "100%" }}
          onClick={(e) => setSelectedMenu(e.key)}
        >
          <Menu.Item key="quiz">3択クイズの管理</Menu.Item>
          <Menu.Item key="riddle">なぞなぞの管理</Menu.Item>
          <Divider />
          <Menu.Item key="web_recommend">Webおすすめ</Menu.Item>
          <Menu.Item key="youtube_recommend">Youtubeおすすめ</Menu.Item>
          <Divider />
          <Menu.Item key="chat_time_limit">チャット時間制限</Menu.Item>
          <Menu.Item key="userweb_notice_all">ユーザーWeb全体お知らせ</Menu.Item>
        </Menu>
      </Sider>

      <Content className="content-container">
        <Typography.Title level={4} style={{ marginTop: 0 }}>
          {getTitle()}
        </Typography.Title>
        {renderContent()}
      </Content>
    </Layout>
  );
};

export default SettingsTab;
